import React from "react";
import { useHistory } from "react-router-dom";
import { Property } from "../../../../definitions/property";
import { REVERSE_TYPE_MAP } from "../../../../utils/object";
import { gtag } from "../../../../utils/track";
import Flex from "../../../structure/Flex";
import Button from "../../Button";
import { trackZostelEvent } from "../../../../utils/tracking";
interface PropertyCardProps {
  data: Property;
  destinationSlug: string;
}

const PropertyCard: React.FC<PropertyCardProps> = ({
  data,
  destinationSlug,
}) => {
  const history = useHistory();
  const getOperatorType = (typeCode: string, operatingModel: string) => {
    if (operatingModel === "F") {
      return REVERSE_TYPE_MAP[typeCode] || "zostel";
    } else {
      return "Trusted By Zostel";
    }
  };

  const handleLoadNewProperty = () => {
    window.scrollTo(0, 0);
    gtag("event", "PropertyCard_Click", {
      value: data.name ? data.name : null,
    });
    trackZostelEvent("PropertyCard_Click", {
      value: data.name ? data.name : null,
    });
    history.push(`/zostel/${destinationSlug}/${data.slug}`);
  };
  return (
    <section className="bg-gray-200 max-w-sm rounded-lg shadow-lg hover:shadow-xl mx-1 my-1">
      <Flex items="center" col>
        <div className="w-full relative">
          <img
            src={data.images[0]?.image}
            alt=""
            className="rounded-t-lg w-full h-40"
          />
          <div className="absolute top-0 right-0 bg-white text-primary font-medium m-2 p-1 rounded-md text-xs">
            <span>
              {getOperatorType(
                data.type_code,
                data.operating_model
              ).toUpperCase()}
            </span>
          </div>
        </div>
        <div className="p-2 w-full bg-white rounded-b-lg h-36 flex flex-col">
          <div className="flex-1">
            <div className="w-full text-lg text-primary font-medium line-clamp-1">
              <p>{data.name}</p>
            </div>
            <div className="w-full text-sm text-gray-700 line-clamp-4">
              <p className=" line-clamp-2">{data.short_description}</p>
            </div>
          </div>
          <Button className="mt-2 w-full" onClick={handleLoadNewProperty}>
            Explore Now
          </Button>
        </div>
      </Flex>
    </section>
  );
};

export default PropertyCard;
